export const API_KEY = 'ba500528996a63e067bc118809a9c2a1';
export const BASE_URL = 'https://api.themoviedb.org/3';